import type { INotification } from "../../../../types/models/notification.models.types";
import { usePostHttp } from "../../http.hook";

interface IBody extends INotification {
  creators: Array<string>;
}

export function useSendTestNotificationAdminHttp() {
  return usePostHttp<IBody, null>({
    path: "/admin/notifications/test",
  });
}
